<ng-container *transloco="let t">
  <div class="prijemni-formular">
    <div [formGroup]="form">
      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{
          t(
            'Is there anything we should be aware of when your pet visits us, such as food allergies, drug allergies, or handling precautions?'
          )
        }}</mat-label>
        <textarea matInput formControlName="initialNotes" rows="4"></textarea>
      </mat-form-field>

      <div class="mb-3">
        <label class="block mb-1">{{
          t('Has your pet been previously treated by another veterinarian?')
        }}</label>
        <mat-radio-group formControlName="prevTreated">
          <mat-radio-button [value]="t('Yes')">{{ t('Yes') }}</mat-radio-button>
          <mat-radio-button [value]="t('No')">{{ t('No') }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('Rabies vaccination') }}</mat-label>
        <textarea matInput formControlName="vaccineRabies" rows="3"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{
          t('Vaccination against infectious diseases')
        }}</mat-label>
        <textarea
          matInput
          formControlName="vaccineInfectious"
          rows="3"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>{{ t('External parasite protection') }}</mat-label>
        <textarea
          matInput
          formControlName="externalParasites"
          rows="3"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Internal parasite protection') }}</mat-label>
        <textarea
          matInput
          formControlName="internalParasites"
          rows="3"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('How did you hear about us') }}</mat-label>
        <mat-select formControlName="heardFrom">
          <mat-option [value]="t('Friend recommendation')">{{
            t('Friend recommendation')
          }}</mat-option>
          <mat-option [value]="t('Faculty recommendation')">{{
            t('Faculty recommendation')
          }}</mat-option>
          <mat-option [value]="t('Facebook')">{{ t('Facebook') }}</mat-option>
          <mat-option [value]="t('Website')">{{ t('Website') }}</mat-option>
          <mat-option [value]="t('Google search')">{{
            t('Google search')
          }}</mat-option>
          <mat-option [value]="t('Other')">{{ t('Other') }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Note') }}</mat-label>
        <textarea matInput formControlName="note" rows="4"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
